module.exports = __webpack_public_path__ + "5.10685f9b.png";